import React, { useState } from "react";

import {
  MapPin,
  Clock3,
  Phone,
  Mail,
  Navigation,
  ChevronRight,
  ChevronLeft,
  Check,
  Crown,
  ShieldCheck,
  CreditCard,
  Car,
  Users,
  PackageCheck,
  Headphones,
  Store as StoreIcon,
  ExternalLink,
} from "lucide-react";

import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";
import pobladoImage from "../../assets/stores/poblado.png";
import envigadoImage from "../../assets/stores/envigado.png";
import laurelesImage from "../../assets/stores/laureles.png";
import barrioAntioquiaImage from "../../assets/stores/barrio-antioquia.png";
import "../../styles/stores.css";

// =========================================================
// DATOS DE LAS SEDES
// =========================================================

const STORES = [
  {
    id: 1,
    name: "Sede Poblado",
    shortName: "El Poblado, Medellín",
    address: "Cra 43 # 10-45",
    city: "El Poblado, Medellín",
    phone: "+57 300 123 4567",
    email: "poblado@debutscrop.com",

    schedule: [
      "Lun - Sáb: 10:00 a.m. - 10:00 p.m.",
      "Dom: 11:00 a.m. - 8:00 p.m.",
    ],

    color: "green",
    badge: "PRINCIPAL",

    image: pobladoImage,

    gallery: [
      pobladoImage,
    ],

    advantages: [
      {
        icon: PackageCheck,
        text: "Amplio surtido",
      },
      {
        icon: Users,
        text: "Zona lounge y asesoría",
      },
      {
        icon: Car,
        text: "Parqueadero cercano",
      },
    ],

    services: [
      "Atención personalizada",
      "Productos originales",
      "Pago seguro",
      "Parqueadero cercano",
    ],

    description:
      "Nuestra sede principal en El Poblado combina variedad, asesoría especializada y una experiencia completa para encontrar todo lo que necesitas para tu cultivo.",

    mapUrl:
      "https://maps.app.goo.gl/zP22QsSqtwyRPUZ3A",
  },

  {
    id: 2,
    name: "Sede Envigado",
    shortName: "Envigado, Antioquia",
    address: "Cra. 46B #46, Zona 8",
    city: "Envigado, Antioquia",
    phone: "+573022242892",
    email: "info@debutscrop.com",

    schedule: [
      "Lun - Sáb: 10:00 a.m. - 9:00 p.m.",
      "Dom: 11:00 a.m. - 7:00 p.m.",
    ],

    color: "pink",
    badge: "SEDE",

    image: envigadoImage,

    gallery: [
      envigadoImage,
    ],

    advantages: [
      {
        icon: ShieldCheck,
        text: "Equipo especializado",
      },
      {
        icon: PackageCheck,
        text: "Productos de alta calidad",
      },
      {
        icon: Navigation,
        text: "Fácil acceso",
      },
    ],

    services: [
      "Equipo especializado",
      "Productos originales",
      "Asesoría personalizada",
      "Fácil acceso",
    ],

    description:
      "Encuentra en Envigado una experiencia cercana, práctica y especializada, con nuestro equipo listo para ayudarte a elegir los productos adecuados.",

    mapUrl:
      "https://maps.app.goo.gl/qQ1EkgPGdsmbJ2qC7",
  },

  {
    id: 3,
    name: "Sede Laureles",
    shortName: "Laureles, Medellín",
    address: "Cra. 73 #41-40 Loc 102",
    city: "Laureles, Medellín",
    phone: "+57 302 345 6789",
    email: "laureles@debutscrop.com",

    schedule: [
      "Lun - Sáb: 10:00 a.m. - 9:00 p.m.",
      "Dom: 11:00 a.m. - 7:00 p.m.",
    ],

    color: "cyan",
    badge: "SEDE",

    image: laurelesImage,

    gallery: [
      laurelesImage,
    ],

    advantages: [
      {
        icon: PackageCheck,
        text: "Variedad de marcas",
      },
      {
        icon: Users,
        text: "Asesoría especializada",
      },
      {
        icon: StoreIcon,
        text: "Ambiente premium",
      },
    ],

    services: [
      "Variedad de marcas",
      "Asesoría especializada",
      "Ambiente premium",
      "Productos originales",
    ],

    description:
      "La sede Laureles ofrece un ambiente moderno y una selección de productos pensada para quienes buscan variedad y asesoría especializada.",

    mapUrl:
      "https://maps.app.goo.gl/dfG1gReFYeqzp22t6",
      
  },

  {
    id: 4,
    name: "Sede Barrio Antioquia",
    shortName: "Barrio Antioquia, Medellín",
    address: "Cra. 65E #24-49",
    city: "Barrio Antioquia, Medellín",
    phone: "+57 303 456 7890",
    email: "barrioantioquia@debutscrop.com",

    schedule: [
      "Lun - Sáb: 10:00 a.m. - 8:00 p.m.",
      "Dom: 11:00 a.m. - 6:00 p.m.",
    ],

    color: "orange",
    badge: "SEDE",

    image: barrioAntioquiaImage,

    gallery: [
      barrioAntioquiaImage,
    ],

    advantages: [
      {
        icon: CreditCard,
        text: "Precios especiales",
      },
      {
        icon: ShieldCheck,
        text: "Productos de confianza",
      },
      {
        icon: Headphones,
        text: "Atención rápida",
      },
    ],

    services: [
      "Precios especiales",
      "Productos de confianza",
      "Atención rápida",
      "Productos originales",
    ],

    description:
      "Una sede práctica y cercana para encontrar productos de cultivo, accesorios e insumos con atención rápida y personalizada.",

    mapUrl:
    "https://maps.app.goo.gl/f1fgFwBwcaaJFuj9A",
      
  },
];

// =========================================================
// COMPONENTE PRINCIPAL
// =========================================================

export default function Stores() {
  const [selectedStore, setSelectedStore] = useState(STORES[0]);

  const [activeImage, setActiveImage] = useState(0);

  // =======================================================
  // CAMBIAR SEDE
  // =======================================================

  const changeStore = (store) => {
    setSelectedStore(store);

    setActiveImage(0);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // =======================================================
  // SIGUIENTE IMAGEN
  // =======================================================

  const nextImage = () => {
    setActiveImage((current) => {
      if (current === selectedStore.gallery.length - 1) {
        return 0;
      }

      return current + 1;
    });
  };

  // =======================================================
  // IMAGEN ANTERIOR
  // =======================================================

  const previousImage = () => {
    setActiveImage((current) => {
      if (current === 0) {
        return selectedStore.gallery.length - 1;
      }

      return current - 1;
    });
  };

  return (
    <div className="stores-page">

      {/* ===================================================
          NAVBAR
      =================================================== */}

      <Navbar />

      {/* ===================================================
          HERO
      =================================================== */}

      <section className="stores-hero">

        <div className="stores-hero-overlay" />

        <div className="stores-hero-content">

          {/* TÍTULO */}

          <div className="stores-title-block">

            <div className="stores-title-small">

              <MapPin size={25} />

              NUESTRAS

            </div>

            <h1>
              <span>SEDES</span>
            </h1>

            <div className="stores-title-line" />

          </div>

          {/* DESCRIPCIÓN */}

          <div className="stores-hero-description">

            <div className="stores-hero-pin">

              <MapPin
                size={55}
                strokeWidth={1.8}
              />

            </div>

            <div>

              <strong>
                4 SEDES, LA MISMA PASIÓN
              </strong>

              <p>
                Encuentra la experiencia Debuts Crop
                más cerca de ti.
                <br />
                Visítanos en nuestras sedes y vive
                el ambiente, la asesoría y todo lo
                que necesitas para tu cultivo.
              </p>

            </div>

          </div>

          {/* BENEFICIOS */}

          <div className="stores-benefits">

            <Benefit
              icon={Users}
              title="ATENCIÓN"
              text="PERSONALIZADA"
            />

            <Benefit
              icon={ShieldCheck}
              title="PRODUCTOS"
              text="ORIGINALES"
            />

            <Benefit
              icon={PackageCheck}
              title="ASESORÍA"
              text="ESPECIALIZADA"
            />

            <Benefit
              icon={StoreIcon}
              title="TIENDAS"
              text="FÍSICAS"
            />

          </div>

        </div>

      </section>

      {/* ===================================================
          CONTENIDO PRINCIPAL
      =================================================== */}

      <main className="stores-main">

        {/* =================================================
            TARJETAS DE LAS SEDES
        ================================================= */}

        <section className="stores-grid">

          {STORES.map((store) => (
            <StoreCard
              key={store.id}
              store={store}
              selected={selectedStore.id === store.id}
              onSelect={() => changeStore(store)}
            />
          ))}

        </section>

        {/* =================================================
            DETALLE DE LA SEDE
        ================================================= */}

        <section
          className={`
            store-detail
            store-detail-${selectedStore.color}
          `}
        >

          {/* GALERÍA */}

          <div className="store-detail-gallery">

            <div className="store-main-photo">

              <img
                src={selectedStore.gallery[activeImage]}
                alt={selectedStore.name}
              />

              <div className="store-photo-count">

                {activeImage + 1}
                /
                {selectedStore.gallery.length}

              </div>

              <button
                type="button"
                className="
                  store-gallery-arrow
                  store-gallery-prev
                "
                onClick={previousImage}
                aria-label="Imagen anterior"
              >

                <ChevronLeft size={24} />

              </button>

              <button
                type="button"
                className="
                  store-gallery-arrow
                  store-gallery-next
                "
                onClick={nextImage}
                aria-label="Siguiente imagen"
              >

                <ChevronRight size={24} />

              </button>

            </div>

            {/* MINIATURAS */}

            <div className="store-thumbnails">

              {selectedStore.gallery.map(
                (image, index) => (

                  <button
                    type="button"
                    key={`${selectedStore.id}-${index}`}
                    className={
                      index === activeImage
                        ? "store-thumbnail active"
                        : "store-thumbnail"
                    }
                    onClick={() => setActiveImage(index)}
                    aria-label={`Ver imagen ${index + 1}`}
                  >

                    <img
                      src={image}
                      alt={`${selectedStore.name} ${index + 1}`}
                    />

                  </button>

                )
              )}

            </div>

          </div>

          {/* =================================================
              INFORMACIÓN
          ================================================= */}

          <div className="store-detail-info">

            <div className="store-detail-title-row">

              <div>

                <div className="store-detail-kicker">

                  <Crown size={17} />

                  {selectedStore.badge === "PRINCIPAL"
                    ? "SEDE PRINCIPAL"
                    : "NUESTRA SEDE"}

                </div>

                <h2>
                  {selectedStore.name}
                </h2>

                <p className="store-detail-location">
                  {selectedStore.city}
                </p>

              </div>

              {selectedStore.badge === "PRINCIPAL" && (
                <span className="store-principal-badge">

                  <Crown size={15} />

                  PRINCIPAL

                </span>
              )}

            </div>

            {/* INFORMACIÓN */}

            <div className="store-info-list">

              <div className="store-info-item">

                <MapPin />

                <div>

                  <strong>
                    Dirección
                  </strong>

                  <span>
                    {selectedStore.address}
                  </span>

                  <span>
                    {selectedStore.city}
                  </span>

                </div>

              </div>

              <div className="store-info-item">

                <Phone />

                <div>

                  <strong>
                    Teléfono
                  </strong>

                  <span>
                    {selectedStore.phone}
                  </span>

                </div>

              </div>

              <div className="store-info-item">

                <Mail />

                <div>

                  <strong>
                    Correo
                  </strong>

                  <span>
                    {selectedStore.email}
                  </span>

                </div>

              </div>

              <div className="store-info-item">

                <Clock3 />

                <div>

                  <strong>
                    Horario
                  </strong>

                  {selectedStore.schedule.map(
                    (item) => (
                      <span key={item}>
                        {item}
                      </span>
                    )
                  )}

                </div>

              </div>

            </div>

            {/* DESCRIPCIÓN */}

            <div className="store-detail-description">

              {selectedStore.description}

            </div>

            {/* BOTONES */}

            <div className="store-detail-buttons">

              <a
                href={selectedStore.mapUrl}
                target="_blank"
                rel="noreferrer"
                className="store-map-button"
              >

                <Navigation size={18} />

                VER EN GOOGLE MAPS

                <ExternalLink size={15} />

              </a>

              <a
                href={`tel:${selectedStore.phone.replace(
                  /\s/g,
                  ""
                )}`}
                className="store-call-button"
              >

                <Phone size={18} />

                LLAMAR

              </a>

            </div>

          </div>

          {/* =================================================
              SERVICIOS
          ================================================= */}

          <div className="store-detail-services">

            <div className="store-services-title">

              <h3>
                ¿QUÉ PUEDES ENCONTRAR AQUÍ?
              </h3>

              <span />

            </div>

            <div className="store-services-grid">

              {selectedStore.services.map(
                (service) => (

                  <div
                    className="store-service-item"
                    key={service}
                  >

                    <Check size={18} />

                    <span>
                      {service}
                    </span>

                  </div>

                )
              )}

            </div>

          </div>

        </section>

        {/* =================================================
            OTRAS SEDES
        ================================================= */}

        <section className="other-stores">

          <div className="other-stores-heading">

            <span>
              DESCUBRE
            </span>

            <h2>
              NUESTRAS OTRAS{" "}
              <b>SEDES</b>
            </h2>

            <p>
              Encuentra la tienda Debuts Crop
              más cercana a ti.
            </p>

          </div>

          <div className="other-stores-list">

            {STORES.map((store) => (

              <button
                type="button"
                key={store.id}
                className={
                  selectedStore.id === store.id
                    ? "other-store active"
                    : "other-store"
                }
                onClick={() => changeStore(store)}
              >

                <span
                  className={`
                    other-store-dot
                    ${store.color}
                  `}
                />

                <span>
                  {store.name}
                </span>

                <ChevronRight size={18} />

              </button>

            ))}

          </div>

        </section>

        {/* =================================================
            MENSAJE FINAL
        ================================================= */}

        <section className="stores-final">

          <div className="stores-final-glow" />

          <div className="stores-final-content">

            <div className="stores-final-crown">

              <Crown size={45} />

            </div>

            <span>
              TU CULTIVO
            </span>

            <h2>
              TU ESTILO
            </h2>

            <p>
              Visítanos en cualquiera de nuestras
              sedes y descubre la experiencia
              Debuts Crop.
            </p>

            <div className="stores-final-line" />

            <div className="stores-final-social">

              <span>
                DEBUTS CROP · MEDELLÍN
              </span>

            </div>

          </div>

        </section>

      </main>

      {/* ===================================================
          FOOTER
      =================================================== */}

      <Footer />

    </div>
  );
}

// =========================================================
// BENEFIT
// =========================================================

function Benefit({
  icon: Icon,
  title,
  text,
}) {
  return (
    <div className="stores-benefit">

      <div className="stores-benefit-icon">

        <Icon
          size={31}
          strokeWidth={1.7}
        />

      </div>

      <strong>
        {title}
      </strong>

      <span>
        {text}
      </span>

    </div>
  );
}

// =========================================================
// TARJETA DE SEDE
// =========================================================

function StoreCard({
  store,
  selected,
  onSelect,
}) {
  return (
    <article
      className={`
        store-card
        store-card-${store.color}
        ${selected ? "selected" : ""}
      `}
    >

      {/* =================================================
          ENCABEZADO TARJETA
      ================================================= */}

      <div className="store-card-top">

        <span className="store-card-name">

          <MapPin size={17} />

          {store.name}

        </span>

        {store.badge === "PRINCIPAL" && (
          <span className="store-card-principal">

            <Crown size={14} />

            PRINCIPAL

          </span>
        )}

      </div>

      {/* =================================================
          FOTO
      ================================================= */}

      <button
        type="button"
        className="store-card-image"
        onClick={onSelect}
        aria-label={`Ver ${store.name}`}
      >

        <img
          src={store.image}
          alt={store.name}
        />

        <span className="store-card-image-overlay" />

      </button>

      {/* =================================================
          CONTENIDO
      ================================================= */}

      <div className="store-card-body">

        {/* DIRECCIÓN */}

        <div className="store-card-location">

          <MapPin />

          <div>

            <strong>
              {store.address}
            </strong>

            <span>
              {store.city}
            </span>

          </div>

        </div>

        {/* HORARIO */}

        <div className="store-card-hours">

          <Clock3 />

          <div>

            {store.schedule.map(
              (schedule) => (

                <span key={schedule}>
                  {schedule}
                </span>

              )
            )}

          </div>

        </div>

        {/* VENTAJAS */}

        <div className="store-card-advantages">

          {store.advantages.map(
            (advantage) => {

              const Icon = advantage.icon;

              return (
                <div
                  className="store-card-advantage"
                  key={advantage.text}
                >

                  <Icon size={20} />

                  <span>
                    {advantage.text}
                  </span>

                </div>
              );
            }
          )}

        </div>

        {/* BOTÓN */}

        <button
          type="button"
          className="store-card-button"
          onClick={onSelect}
        >

          VER DETALLES

          <ChevronRight size={18} />

        </button>

      </div>

    </article>
  );
}